export default class ContractorAuthPolicies {
    public create = false
    public read = false
    public readFinancial = false
    public updateFinancial = false
    public update = false
    public updateAdmin = false
}
